import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

const PILLARS = [
  { k: "Framework", v: "Consciousness as Generative Field" },
  { k: "Method", v: "Physics-literate, myth-aware synthesis" },
  { k: "Output", v: "Papers, manifestos & field studies" },
];

export const About = ({ settings }) => (
  <section id="about" className="relative py-28 md:py-36" data-testid="about-section">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_15%_30%,rgba(29,233,182,0.05),transparent_45%)]" />
    <div className="section-shell relative grid grid-cols-1 gap-16 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <SectionHeader index="04" overline="The Inquirer" title="Austin Cundall" />
        <Reveal>
          <div className="space-y-6 font-sans text-base md:text-lg font-light leading-relaxed text-slate-300">
            <p>
              Austin Cundall is an independent researcher working at the seam between physics,
              archaeology, and the study of consciousness. His work asks a deceptively simple
              question: what if the stone was never inert — what if resonance is a language that
              matter, mind, and myth have always shared?
            </p>
            <p>
              Across papers on piezoelectric granite, magnetite-mediated coupling, and the UAP
              phenomenon, he builds a single, testable framework: consciousness treated not as a
              byproduct of matter but as a generative field in resonance with it. The aim is
              rigor without reduction — hypotheses that can be instrumented, measured, and revised.
            </p>
            <p>
              The Resonant Spark Project is the living archive of that inquiry: peer-facing
              research, an evolving manifesto, and field studies in progress — kept open so
              collaborators, scholars, and curious readers can follow the synthesis as it forms.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-5">
        <Reveal delay={0.15} className="glass-card sticky top-28 rounded-xl p-8">
          <p className="overline mb-6">Framework at a glance</p>
          <div className="space-y-6">
            {PILLARS.map((p) => (
              <div key={p.k} className="border-l border-plasma-teal/30 pl-5">
                <div className="font-mono text-[10px] uppercase tracking-widest text-plasma-teal/70">{p.k}</div>
                <div className="mt-1 font-display text-xl font-light text-white">{p.v}</div>
              </div>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-4 border-t border-white/10 pt-6">
            <a href={settings?.socialLinks?.substack} target="_blank" rel="noreferrer" className="font-mono text-xs uppercase tracking-widest text-slate-400 hover:text-plasma-teal" data-testid="about-substack">Substack</a>
            <a href={settings?.socialLinks?.x} target="_blank" rel="noreferrer" className="font-mono text-xs uppercase tracking-widest text-slate-400 hover:text-plasma-teal" data-testid="about-x">X</a>
            <a href={settings?.socialLinks?.academia} target="_blank" rel="noreferrer" className="font-mono text-xs uppercase tracking-widest text-slate-400 hover:text-plasma-teal" data-testid="about-academia">Academia</a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
